//@flow

import React, { Component } from 'react';
import { Alert } from 'reactstrap';

import config from '../../config';
import ErrorBoundary from '../ErrorBoundary';

import './mt.css';

type Point = {
  coordinates: Array<number>,
  label: string,
  altitude: { meters: number, feet: number },
};

type Props = {
  mountainFinder: {
    id: string,
    link: null,
    points: Array<Point>,
    primaryImage: string,
  },
};

type State = { visible: boolean };

export default class MoutainFinder extends Component<Props, State> {
  state = { visible: false };

  componentDidMount() {
    const { init, mountainImage, drawMountainImage, plotMountainNames } = this;

    init();

    mountainImage.onload = () => {
      try{
        drawMountainImage();
        plotMountainNames();
      } catch(err) {
        console.log(err);
      }
    };

    if (window.innerWidth < 768) this.showMessage();

    this.addEventListeners();
  }

  componentWillUnmount() {
    this.removeEventListeners();
  }

  render() {
    return (
      <ErrorBoundary>
        <section className="no-gutters" id="mountainFinder">
          <section className="col-12">
            <div className="white-panel">
              <h2>MOUNTAIN FINDER</h2>
              <div className="mt-finder">
                <div
                  id="mountain_container"
                  className="mb-3"
                  ref={div => {
                    this.mountainContainer = div;
                  }}
                >
                  <canvas
                    ref={canvas => {
                      this.canvas = canvas;
                    }}
                    onClick={this.handleClick}
                    id="canvas"
                  >
                    <img
                      src={`${config.RESOURCE_URL}/${
                        this.props.mountainFinder.primaryImage
                      }`}
                      alt={`${this.props.placeName}-mountainFinder`}
                      id="mt"
                      ref={img => {
                        this.mountainImage = img;
                      }}
                    />
                  </canvas>
                </div>

                <Alert color="info" isOpen={this.state.visible} toggle={this.showMessage}>
                  <p>
                    To view the Mountain Finder. Best view of Mountain Finder is in
                    landscape mode to do so you have to rotate you device.{' '}
                  </p>
                </Alert>
              </div>
            </div>
          </section>
        </section>
      </ErrorBoundary>
    );
  }

  init = () => {
    this.img = new Image();
    this.ctx = this.canvas.getContext('2d');
  };

  drawMountainImage = () => {
    const { img, mountainImage, canvas, ctx } = this;

    img.src = mountainImage.src;
    canvas.height = img.height;
    canvas.width = img.width;
    ctx.drawImage(img, 0, 0);
  };

  plotMountainNames = () => {
    const {
      ctx,
      props: { mountainFinder },
    } = this;

    mountainFinder.points.forEach(({ label, coordinates, altitude }) => {
      const altitudeWithMeters = altitude ? `${altitude.meters.toLocaleString()}m` : '';
      const labelWithAltitude = `${label} ${altitudeWithMeters}`;

      ctx.font = '35px helvetica';
      ctx.fillStyle = '#FFF';
      ctx.textAlign = 'center';

      ctx.fillText(labelWithAltitude, coordinates[0], coordinates[1]);
    });
  };

  showMessage = () => this.setState({ visible: !this.state.visible });

  handleScreenChange = () => {
    // Save scrollbar position before entering Fullscreen
    const d = document,
      r = d.documentElement,
      b = d.body;

    const sx = r.scrollLeft || b.scrollLeft || 0;
    const sy = r.scrollTop || b.scrollTop || 0;
    const yOffsetScrollTo = sy + document.getElementById('mountainFinder').clientHeight;

    // const sy = document.getElementById('mountainFinder').offsetTop;

    // When player exit full screen,
    const isFullScreen = this.checkFullScreen();
    if (!isFullScreen) window.scrollTo(sx, yOffsetScrollTo);
  };

  checkFullScreen = () =>
    !!(
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement
    );

  handleClick = () => {
    const el = this.mountainContainer;

    const requestFullScreen =
      el.requestFullscreen ||
      el.msRequestFullscreen ||
      el.mozRequestFullScreen ||
      el.webkitRequestFullscreen ||
      // el.webkitEnterFullscreen ||
      el.webkitbeginfullscreen;

    if (requestFullScreen) requestFullScreen.call(el);
    else return;
  };

  addEventListeners = () => {
    document.addEventListener('fullscreenchange', this.handleScreenChange, false);
    document.addEventListener('webkitfullscreenchange', this.handleScreenChange, false);
    document.addEventListener('mozfullscreenchange', this.handleScreenChange, false);
  };

  removeEventListeners = () => {
    document.removeEventListener('fullscreenchange', this.handleScreenChange, false);
    document.removeEventListener('webkitfullscreenchange', this.handleScreenChange, false);
    document.removeEventListener('mozfullscreenchange', this.handleScreenChange, false);
  };
}



// WEBPACK FOOTER //
// ./src/components/MountainFinder/MountainFinder.jsx